import { ColorPicker, useColor } from 'react-color-palette';
import 'react-color-palette/css';

import React, { useEffect } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import { Box, Typography, useTheme } from '@mui/material';
import { Svg } from './VSvg';

interface IConfirmationDialog {
  isOpen: boolean;
  onClose: () => void;
  onColorChange: (color: string) => void;
  svg?: string;
}

export const VColorPiker: React.FC<IConfirmationDialog> = ({
  isOpen,
  onClose,
  onColorChange,
  svg
}) => {

  const [color, setColor] = useColor('rgb(0 0 0)');
  const theme = useTheme();
  const smDow = theme.breakpoints.down('sm');

  useEffect(() => {
    handleColorChange(color.hex);
  }, [color]);

  const handleColorChange = (newColor: string) => {
    onColorChange(newColor);
  };
  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogContent>
        <Box display='flex' justifyContent={'end'} marginTop={-2}>
        </Box>
          <Box width={smDow? 250 : 300} padding={2}>
            <div className='color-piker'>
              <ColorPicker color={color} onChange={setColor} hideAlpha={true} hideInput={true}/>
            </div>
          </Box>
          {svg != undefined? (
            <Box display='flex' alignItems='center' justifyContent='center' >
              <Typography>Pré-visualização: </Typography>
              <Svg fill={color.hex} height={40} width={40} svgContent={svg} />
            </Box>         
          ) : (<></>)}
      </DialogContent>
    </Dialog>
  );
};
